import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { MaintenanceMode } from '#core/maintenance/models/maintenance.interface';
import { MaintenanceStore } from '#core/store/maintenance.store';
import { environment } from '#environments/environment';

@Injectable()
export class MaintenanceHeaderInterceptor implements HttpInterceptor {
    private readonly _maintenanceStore = inject(MaintenanceStore);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap((event) => {
                if (event instanceof HttpResponse && req.url.startsWith(environment.APP_MALOU_API_URL)) {
                    const maintenanceHeader = event.headers.get('X-Maintenance-Status');
                    if (maintenanceHeader) {
                        try {
                            const maintenanceMode: MaintenanceMode = JSON.parse(maintenanceHeader);
                            this._maintenanceStore.editMaintenance(maintenanceMode);
                        } catch (error) {
                            console.warn('Error parsing maintenance header:', error);
                        }
                    }
                }
            })
        );
    }
}
